<template>
    <v-card max-width="500" class="mx-auto">
        <v-card-actions>
            <v-btn text color="blue-grey" router :to="{ name: 'Games'}">
                <v-icon>mdi-arrow-left</v-icon>
                <span class="ml-2">돌아가기</span>
            </v-btn>
        </v-card-actions>
        <v-img
            class="blue-grey--text"
            height="480px"
            src="/tears.jpg"
        >
            <v-card-title class="align-end fill-height">가지마~~~</v-card-title>
        </v-img>
        <v-card-text>
            <p class="text-center my-5 pt-5"><span class="title indigo--text pr-3">은탁선</span>을 떠나시려구요?</p>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading='loading' depressed dark class="my-5" color="blue-grey" @click="signout">Yes!</v-btn>
            <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
</template>

<script>
import db from '@/fb'

export default {
    name: 'Signout',
    data: () => ({
        loading: false,
        user: null,
        groupId: null,
        group: null

    }),
    methods: {
        signout(){
            this.loading = true;

            // delete the member from the group
            let newMembers = []; 
            this.group.members.filter(member => {
                if(member.alias != this.user.alias){
                    newMembers.push(member)
                }
            })
            this.group.members = newMembers;

            // delete the group from the user info
            let newJoinedGroups = [];
            this.user.joinedGroups.filter(group => {
                if(group.id != this.groupId){
                    newJoinedGroups.push(group)
                }
            })

            if(newMembers.length == 0){
                // delete the group from firestore
                db.collection('groups').doc(this.groupId).delete().then(() => {
                    // update the user info
                    db.collection('users').doc(this.user.id).update({
                        joinedGroups: newJoinedGroups
                    }).then(() => {
                        this.dialog = false;
                        this.loading = false;
                        this.$router.push({ name: 'MyPage' });
                    });
                })
            } else {
                if(this.group.creator.alias == this.user.alias){
                    console.log('the creator is going out from the group')

                    // update the members of the group
                    db.collection('groups').doc(this.groupId).update({
                        members: newMembers
                    }).then(() => {
                        // update the user info
                        db.collection('users').doc(this.user.id).update({
                            joinedGroups: newJoinedGroups
                        }).then(() => {
                            this.$router.push({
                                name: 'PassOn', 
                                params: {
                                    group_id: this.groupId,
                                    user: this.user,
                                    group: this.group,
                                }
                            })
                        })
                    })
                } else {
                    // update the members of the group
                    db.collection('groups').doc(this.groupId).update({
                        members: newMembers
                    }).then(() => {
                        // update the user info
                        db.collection('users').doc(this.user.id).update({
                            joinedGroups: newJoinedGroups
                        }).then(() => {
                            this.dialog = false;
                            this.loading = false;
                            this.$router.push({ name: 'MyPage' });
                        });
                    })
                }
            }
        }
    },
    created(){
        this.user = this.$route.params.user;
        this.groupId = this.$route.params.group_id;
        this.group = this.$route.params.group;
    }
}
</script>

<style>

</style>